module.exports = __webpack_public_path__ + "img/bank.eceab148.png";